<div class="main__container">

	<breadcrumb></breadcrumb>

	<div class="section__container">
		<div class="box__container titulo__container">
			<p class="titulo">Reporte de Faltantes</p>
		</div>

		<div class="contenido__box">
			<div class="contenido__container" [managedLink]="faltantesFormKey">
				<img src="/assets/images/reporte/faltantes.png" >
			</div>
		</div>
	</div>
</div>

